/* Aroma Home – theme.js (sin dependencias) */
(function () {
  'use strict';

  var qs = function (s, c) { return (c || document).querySelector(s); };
  var qsa = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var theme = window.theme || {};
  var routes = theme.routes || {};
  var root = (routes.root || '/').replace(/\/?$/, '/');

  /* ------------------------------------------------------------------ */
  /* Dinero                                                              */
  /* ------------------------------------------------------------------ */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || theme.moneyFormat || '{{amount_with_comma_separator}} €';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var n = (number / 100).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var m = format.match(placeholder);
    if (!m) return format;
    var value;
    switch (m[1]) {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = fmt(cents, 2, ' ', '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(placeholder, value);
  }
  theme.formatMoney = formatMoney;

  /* ------------------------------------------------------------------ */
  /* Bloqueo de scroll y foco para cajones                               */
  /* ------------------------------------------------------------------ */
  var openLayers = 0;
  function lockScroll(on) {
    openLayers = Math.max(0, openLayers + (on ? 1 : -1));
    document.body.classList.toggle('is-locked', openLayers > 0);
  }
  function trapFocus(container, e) {
    if (e.key !== 'Tab') return;
    var f = qsa('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', container)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ------------------------------------------------------------------ */
  /* Barra de anuncios                                                   */
  /* ------------------------------------------------------------------ */
  function initAnnouncements() {
    qsa('[data-announcement]').forEach(function (el) {
      if (el._init) return; el._init = true;
      var msgs = qsa('.announcement__msg', el);
      if (msgs.length < 2) return;
      var i = 0, timer = null;
      var delay = (parseInt(el.dataset.interval, 10) || 5) * 1000;
      function show(n) {
        msgs[i].classList.remove('is-active');
        i = (n + msgs.length) % msgs.length;
        msgs[i].classList.add('is-active');
      }
      function start() { stop(); timer = setInterval(function () { show(i + 1); }, delay); }
      function stop() { if (timer) clearInterval(timer); }
      var prev = qs('[data-ann-prev]', el), next = qs('[data-ann-next]', el);
      if (prev) prev.addEventListener('click', function () { show(i - 1); start(); });
      if (next) next.addEventListener('click', function () { show(i + 1); start(); });
      el.addEventListener('mouseenter', stop);
      el.addEventListener('mouseleave', start);
      start();
    });
  }

  /* ------------------------------------------------------------------ */
  /* Cabecera y menú móvil                                               */
  /* ------------------------------------------------------------------ */
  function initHeader() {
    var header = qs('[data-header]');
    if (header) {
      var setH = function () { document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px'); };
      setH();
      window.addEventListener('resize', setH, { passive: true });
    }

    var drawer = qs('[data-menu-drawer]');
    if (!drawer || drawer._init) return;
    drawer._init = true;
    var panel = qs('.menu-drawer__panel', drawer);
    var toggles = qsa('[data-menu-open]');
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
      lockScroll(true);
      setTimeout(function () { panel.focus(); }, 50);
    }
    function close() {
      if (!drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      lockScroll(false);
      if (lastFocus) lastFocus.focus();
    }
    toggles.forEach(function (t) { t.addEventListener('click', open); });
    qsa('[data-menu-close]', drawer).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (!drawer.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      trapFocus(panel, e);
    });
    window.matchMedia('(min-width: 990px)').addEventListener('change', function (mq) { if (mq.matches) close(); });
  }

  /* ------------------------------------------------------------------ */
  /* Carrito lateral                                                     */
  /* ------------------------------------------------------------------ */
  var Cart = {
    el: null,
    lastFocus: null,
    init: function () {
      this.el = qs('[data-cart-drawer]');
      var self = this;

      document.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-cart-open]');
        if (opener && self.el) { e.preventDefault(); self.open(); return; }

        var closer = e.target.closest('[data-cart-close]');
        if (closer && self.el && self.el.contains(closer)) {
          if (closer.tagName === 'A' && !closer.hasAttribute('href')) e.preventDefault();
          if (closer.tagName !== 'A') e.preventDefault();
          self.close();
          return;
        }

        var quick = e.target.closest('[data-quick-add]');
        if (quick) {
          e.preventDefault();
          self.setLoading(quick, true);
          self.add([{ id: Number(quick.dataset.quickAdd), quantity: 1 }])
            .then(function () { self.open(); })
            .catch(function (err) { self.showError(err.message); })
            .finally(function () { self.setLoading(quick, false); });
          return;
        }

        var qtyBtn = e.target.closest('[data-cart-qty]');
        if (qtyBtn) {
          self.change(Number(qtyBtn.dataset.cartQty), Number(qtyBtn.dataset.qtyValue));
          return;
        }
        var rm = e.target.closest('[data-cart-remove]');
        if (rm) { self.change(Number(rm.dataset.cartRemove), 0); }
      });

      document.addEventListener('change', function (e) {
        var input = e.target.closest('[data-cart-qty-input]');
        if (input) {
          var v = Math.max(0, parseInt(input.value, 10) || 0);
          self.change(Number(input.dataset.cartQtyInput), v);
        }
      });

      document.addEventListener('keydown', function (e) {
        if (!self.el || !self.el.classList.contains('is-open')) return;
        if (e.key === 'Escape') { self.close(); return; }
        trapFocus(qs('[data-cart-panel]', self.el), e);
      });
    },
    open: function () {
      if (!this.el) { window.location.href = routes.cart || '/cart'; return; }
      if (this.el.classList.contains('is-open')) return;
      this.lastFocus = document.activeElement;
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      var panel = qs('[data-cart-panel]', this.el);
      setTimeout(function () { panel && panel.focus(); }, 60);
    },
    close: function () {
      if (!this.el || !this.el.classList.contains('is-open')) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      lockScroll(false);
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },
    setLoading: function (btn, on) {
      if (!btn) return;
      btn.classList.toggle('is-loading', on);
      btn.disabled = on;
    },
    request: function (url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) {
            var msg = data.description || data.message || (theme.strings && theme.strings.cartError) || 'Error';
            throw new Error(typeof msg === 'string' ? msg : (theme.strings && theme.strings.cartError));
          }
          return data;
        });
      });
    },
    add: function (items) {
      var self = this;
      return this.request(root + 'cart/add.js', { items: items, sections: 'cart-drawer', sections_url: window.location.pathname })
        .then(function (data) {
          if (data.sections && data.sections['cart-drawer']) self.render(data.sections['cart-drawer']);
          else return self.refresh();
          document.dispatchEvent(new CustomEvent('cart:updated'));
          return data;
        });
    },
    change: function (line, quantity) {
      var self = this;
      var body = this.el && qs('[data-cart-body]', this.el);
      if (body) body.classList.add('is-loading');
      return this.request(root + 'cart/change.js', { line: line, quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
        .then(function (data) {
          if (data.sections && data.sections['cart-drawer']) self.render(data.sections['cart-drawer']);
          document.dispatchEvent(new CustomEvent('cart:updated'));
        })
        .catch(function (err) {
          self.refresh().then(function () { self.showError(err.message); });
        })
        .finally(function () {
          var b = self.el && qs('[data-cart-body]', self.el);
          if (b) b.classList.remove('is-loading');
        });
    },
    refresh: function () {
      var self = this;
      return fetch(root + '?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) { if (data['cart-drawer']) self.render(data['cart-drawer']); });
    },
    render: function (html) {
      if (!this.el) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newPanel = qs('[data-cart-panel]', doc);
      var panel = qs('[data-cart-panel]', this.el);
      if (newPanel && panel) {
        var scroll = qs('[data-cart-body]', panel);
        var top = scroll ? scroll.scrollTop : 0;
        panel.innerHTML = newPanel.innerHTML;
        var ns = qs('[data-cart-body]', panel);
        if (ns) ns.scrollTop = top;
        if (this.el.classList.contains('is-open') && !panel.contains(document.activeElement)) panel.focus();
      }
      var countEl = qs('[data-cart-count-value]', doc);
      var count = countEl ? parseInt(countEl.dataset.cartCountValue, 10) || 0 : 0;
      qsa('[data-cart-count]').forEach(function (b) {
        b.textContent = count;
        b.classList.toggle('is-empty', count === 0);
      });
    },
    showError: function (msg) {
      var box = this.el && qs('[data-cart-error]', this.el);
      if (box) { box.textContent = msg; box.hidden = false; this.open(); }
      else window.alert(msg);
    }
  };
  theme.cart = Cart;

  /* ------------------------------------------------------------------ */
  /* Galería de producto                                                 */
  /* ------------------------------------------------------------------ */
  function Gallery(el) {
    this.el = el;
    this.track = qs('[data-gallery-track]', el);
    this.dotsWrap = qs('[data-gallery-dots]', el);
    this.thumbs = qsa('[data-thumb-for]', el);
    this.prev = qs('[data-gallery-prev]', el);
    this.next = qs('[data-gallery-next]', el);
    this.index = 0;
    var self = this;

    this.thumbs.forEach(function (t) {
      t.addEventListener('click', function () { self.goToMedia(t.dataset.thumbFor); });
    });
    if (this.prev) this.prev.addEventListener('click', function () { self.goTo(self.index - 1); });
    if (this.next) this.next.addEventListener('click', function () { self.goTo(self.index + 1); });

    var ticking = false;
    this.track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { self.sync(); ticking = false; });
    }, { passive: true });

    el.addEventListener('gallery:goto', function (e) { self.goToMedia(e.detail.mediaId, true); });
    this.mq = window.matchMedia('(min-width: 990px)');
    this.mq.addEventListener('change', function () { self.buildDots(); self.goTo(0, true); });
    window.addEventListener('resize', function () { self.goTo(self.index, true); }, { passive: true });

    this.buildDots();
    var active = qs('.gallery__thumb.is-active', el);
    if (active) this.goToMedia(active.dataset.thumbFor, true);
    this.sync();
  }
  Gallery.prototype.slides = function () {
    return qsa('[data-gallery-slide]', this.track).filter(function (s) { return s.offsetParent !== null || s.getClientRects().length; });
  };
  Gallery.prototype.buildDots = function () {
    if (!this.dotsWrap) return;
    var self = this;
    var slides = this.slides();
    this.dotsWrap.innerHTML = '';
    if (slides.length < 2) return;
    slides.forEach(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gallery__dot';
      b.tabIndex = -1;
      b.addEventListener('click', function () { self.goTo(i); });
      self.dotsWrap.appendChild(b);
    });
  };
  Gallery.prototype.goTo = function (i, instant) {
    var slides = this.slides();
    if (!slides.length) return;
    i = Math.max(0, Math.min(slides.length - 1, i));
    this.index = i;
    var left = i * this.track.clientWidth;
    if (instant) {
      var prevBehavior = this.track.style.scrollBehavior;
      this.track.style.scrollBehavior = 'auto';
      this.track.scrollLeft = left;
      this.track.style.scrollBehavior = prevBehavior;
    } else {
      this.track.scrollTo({ left: left, behavior: 'smooth' });
    }
    this.updateUI();
  };
  Gallery.prototype.goToMedia = function (id, instant) {
    var slides = this.slides();
    for (var i = 0; i < slides.length; i++) {
      if (String(slides[i].dataset.mediaId) === String(id)) { this.goTo(i, instant); return; }
    }
  };
  Gallery.prototype.sync = function () {
    var w = this.track.clientWidth || 1;
    var i = Math.round(this.track.scrollLeft / w);
    if (i !== this.index) { this.index = i; }
    this.updateUI();
  };
  Gallery.prototype.updateUI = function () {
    var slides = this.slides();
    var current = slides[this.index];
    var id = current && current.dataset.mediaId;
    this.thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumbFor === id); });
    qsa('.gallery__dot', this.dotsWrap).forEach(function (d, n) { d.classList.toggle('is-active', n === this.index); }, this);
    if (this.prev) this.prev.disabled = this.index <= 0;
    if (this.next) this.next.disabled = this.index >= slides.length - 1;
  };

  /* ------------------------------------------------------------------ */
  /* Caja de compra                                                      */
  /* ------------------------------------------------------------------ */
  function Product(el) {
    this.el = el;
    this.section = el.closest('section') || el.parentNode;
    var json = qs('[data-product-json]', el);
    this.data = json ? JSON.parse(json.textContent) : null;
    if (!this.data) return;
    this.formId = 'ProductForm-' + el.dataset.sectionId;
    this.form = document.getElementById(this.formId);
    this.idInput = this.form ? qs('input[name="id"]', this.form) : null;
    var initialId = this.idInput ? Number(this.idInput.value) : null;
    this.variant = this.data.variants.find(function (v) { return v.id === initialId; }) || this.data.variants[0];
    this.atc = qs('[data-atc]', el);
    this.isMain = !!el.closest('[data-main-product]');
    var self = this;

    el.addEventListener('change', function (e) {
      var t = e.target;
      if (t.closest('[data-variant-picker]')) self.onOptionChange();
      else if (t.matches('[data-purchase-option]')) self.update();
      else if (t.matches('[data-upgrade-checkbox]')) self.update();
    });
    el.addEventListener('click', function (e) {
      var step = e.target.closest('[data-qty-step]');
      if (!step) return;
      var input = qs('input[name="quantity"]', step.parentNode);
      if (!input) return;
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(step.dataset.qtyStep));
    });
    if (this.form) this.form.addEventListener('submit', function (e) { self.onSubmit(e); });

    this.markAvailability();
    this.update();
  }
  Product.prototype.selectedOptions = function () {
    return qsa('[data-option-position]', this.el)
      .sort(function (a, b) { return Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition); })
      .map(function (opt) {
        if (opt.tagName === 'SELECT') return opt.value;
        var checked = qs('input:checked', opt);
        return checked ? checked.value : null;
      });
  };
  Product.prototype.onOptionChange = function () {
    var opts = this.selectedOptions();
    var v = this.data.variants.find(function (variant) {
      return variant.options.every(function (o, i) { return opts[i] === undefined || opts[i] === o; });
    });
    this.variant = v || null;
    qsa('[data-option-position]', this.el).forEach(function (opt) {
      var label = qs('[data-selected-value]', opt);
      var checked = qs('input:checked', opt);
      if (label && checked) label.textContent = checked.value;
    });
    if (v) {
      if (this.idInput) this.idInput.value = v.id;
      if (this.isMain && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      if (v.featured_media) {
        var gal = qs('[data-gallery]', this.section);
        if (gal) gal.dispatchEvent(new CustomEvent('gallery:goto', { detail: { mediaId: v.featured_media.id } }));
      }
    }
    this.markAvailability();
    this.update();
  };
  Product.prototype.markAvailability = function () {
    var self = this;
    var opts = this.selectedOptions();
    qsa('[data-option-position]', this.el).forEach(function (opt) {
      var pos = Number(opt.dataset.optionPosition) - 1;
      qsa('input[type="radio"]', opt).forEach(function (input) {
        var available = self.data.variants.some(function (v) {
          if (!v.available || v.options[pos] !== input.value) return false;
          return v.options.every(function (o, i) { return i === pos || opts[i] === undefined || opts[i] === null || opts[i] === o; });
        });
        input.classList.toggle('is-unavailable', !available);
      });
    });
  };
  Product.prototype.sellingPlanId = function () {
    var checked = qs('[data-purchase-option]:checked', this.el);
    return checked && checked.value ? Number(checked.value) : null;
  };
  Product.prototype.upgrade = function () {
    var box = qs('[data-upgrade-checkbox]', this.el);
    return box && box.checked ? box : null;
  };
  Product.prototype.update = function () {
    var v = this.variant;
    var el = this.el;
    var label = qs('[data-atc-label]', el);
    var priceWrap = qs('[data-atc-price]', el);
    var price = 0, compare = 0, available = false;

    if (v) {
      price = v.price;
      compare = v.compare_at_price || 0;
      available = v.available;
      var plan = this.sellingPlanId();
      if (plan && v.selling_plan_allocations) {
        var alloc = v.selling_plan_allocations.find(function (a) { return a.selling_plan_id === plan; });
        if (alloc) {
          price = alloc.price;
          compare = alloc.compare_at_price > alloc.price ? alloc.compare_at_price : Math.max(compare, alloc.compare_at_price || 0);
        }
      }
      qsa('[data-plan-price]', el).forEach(function (n) {
        var a = (v.selling_plan_allocations || []).find(function (x) { return String(x.selling_plan_id) === n.dataset.planPrice; });
        if (a) n.innerHTML = formatMoney(a.price);
      });
      qsa('[data-subscription-only]', el).forEach(function (n) { n.hidden = !plan; });
    }

    var up = this.upgrade();
    if (up) {
      price = Number(up.dataset.price);
      compare = Number(up.dataset.compare) || 0;
      available = true;
    }

    var hasDiscount = compare > price;
    var pct = hasDiscount ? Math.round((compare - price) * 100 / compare) : 0;

    qsa('[data-price]', el).forEach(function (n) { n.innerHTML = formatMoney(price); });
    qsa('[data-compare-price]', el).forEach(function (n) { n.innerHTML = formatMoney(compare); n.hidden = !hasDiscount; });
    qsa('[data-save-percent]', el).forEach(function (n) { n.textContent = pct; });
    qsa('[data-save-amount]', el).forEach(function (n) { n.innerHTML = formatMoney(compare - price); });
    qsa('[data-discount-only]', el).forEach(function (n) { n.hidden = !hasDiscount; });

    if (this.atc) {
      this.atc.disabled = !available;
      if (label) {
        label.textContent = !v ? theme.strings.unavailable : (available ? (this.atc.dataset.addLabel || theme.strings.addToCart) : theme.strings.soldOut);
      }
      if (priceWrap) priceWrap.hidden = !available;
    }

    document.dispatchEvent(new CustomEvent('product:update', {
      detail: { productId: this.data.id, variant: v, price: price, compare: compare, available: available, isMain: this.isMain }
    }));
  };
  Product.prototype.onSubmit = function (e) {
    e.preventDefault();
    var self = this;
    if (!this.variant || (this.atc && this.atc.disabled)) return;
    var err = qs('[data-form-error]', this.el);
    if (err) err.hidden = true;

    var fd = new FormData(this.form);
    var qty = Math.max(1, parseInt(fd.get('quantity'), 10) || 1);
    var main = { id: this.variant.id, quantity: qty };
    var plan = this.sellingPlanId();
    if (plan) main.selling_plan = plan;
    var props = {};
    fd.forEach(function (val, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m && val !== '') props[m[1]] = val;
    });
    if (Object.keys(props).length) main.properties = props;

    var up = this.upgrade();
    if (up) main = { id: Number(up.dataset.variantId), quantity: qty };
    var items = [main];
    qsa('[data-addon-checkbox]:checked', this.el).forEach(function (box) {
      items.push({ id: Number(box.dataset.variantId), quantity: 1 });
    });

    Cart.setLoading(this.atc, true);
    Cart.add(items)
      .then(function () { Cart.open(); })
      .catch(function (error) {
        if (err) { err.textContent = error.message; err.hidden = false; }
      })
      .finally(function () {
        Cart.setLoading(self.atc, false);
        self.update();
      });
  };

  /* ------------------------------------------------------------------ */
  /* Barra fija de compra                                                */
  /* ------------------------------------------------------------------ */
  function initStickyAtc() {
    var bar = qs('[data-sticky-atc]');
    var main = qs('[data-main-product]');
    if (!bar || !main) return;
    var mainBtn = qs('[data-atc]', main);
    var btn = qs('[data-sticky-atc-btn]', bar);
    if (!mainBtn) { bar.remove(); return; }

    var stickyLabel = qs('[data-sticky-label]', bar);
    var baseLabel = stickyLabel ? stickyLabel.textContent : '';
    var footer = qs('.footer');
    var pastButton = false, footerVisible = false;

    function render() {
      var show = pastButton && !footerVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1;
    }
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      pastButton = !en.isIntersecting && en.boundingClientRect.top < 0;
      render();
    }).observe(mainBtn);
    if (footer) {
      new IntersectionObserver(function (entries) { footerVisible = entries[0].isIntersecting; render(); }).observe(footer);
    }

    btn.addEventListener('click', function () {
      var form = mainBtn.form || mainBtn.closest('form');
      if (!form) return;
      if (form.requestSubmit) form.requestSubmit(mainBtn); else mainBtn.click();
    });

    document.addEventListener('product:update', function (e) {
      var d = e.detail;
      if (!d.isMain) return;
      qsa('[data-price]', bar).forEach(function (n) { n.innerHTML = formatMoney(d.price); });
      qsa('[data-compare-price]', bar).forEach(function (n) { n.innerHTML = formatMoney(d.compare); n.hidden = !(d.compare > d.price); });
      var vt = qs('[data-sticky-variant]', bar);
      if (vt && d.variant && d.variant.title !== 'Default Title') vt.textContent = d.variant.title;
      btn.disabled = !d.available;
      if (stickyLabel) stickyLabel.textContent = d.available ? baseLabel : theme.strings.soldOut;
    });
  }

  /* ------------------------------------------------------------------ */
  /* Carruseles                                                          */
  /* ------------------------------------------------------------------ */
  function initCarousels() {
    qsa('[data-carousel]').forEach(function (c) {
      if (c._init) return; c._init = true;
      var track = qs('[data-carousel-track]', c);
      var prev = qs('[data-carousel-prev]', c);
      var next = qs('[data-carousel-next]', c);
      if (!track) return;
      function step() {
        var item = track.firstElementChild;
        if (!item) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return item.getBoundingClientRect().width + gap;
      }
      function state() {
        if (!prev || !next) return;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', state, { passive: true });
      window.addEventListener('resize', state, { passive: true });
      state();
    });
  }

  /* ------------------------------------------------------------------ */
  /* Acordeones (uno abierto a la vez si se pide)                        */
  /* ------------------------------------------------------------------ */
  function initAccordions() {
    qsa('[data-single-open]').forEach(function (group) {
      qsa('details[data-accordion]', group).forEach(function (d) {
        if (d._init) return; d._init = true;
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          qsa('details[data-accordion]', group).forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Arranque                                                            */
  /* ------------------------------------------------------------------ */
  function init() {
    initAnnouncements();
    initHeader();
    Cart.init();
    qsa('[data-gallery]').forEach(function (g) { if (!g._gallery) g._gallery = new Gallery(g); });
    qsa('[data-product-section]').forEach(function (p) { if (!p._product) p._product = new Product(p); });
    initStickyAtc();
    initCarousels();
    initAccordions();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Editor de temas: re-inicializar al recargar secciones */
  document.addEventListener('shopify:section:load', function () {
    initAnnouncements();
    initHeader();
    Cart.el = qs('[data-cart-drawer]');
    qsa('[data-gallery]').forEach(function (g) { if (!g._gallery) g._gallery = new Gallery(g); });
    qsa('[data-product-section]').forEach(function (p) { if (!p._product) p._product = new Product(p); });
    initCarousels();
    initAccordions();
  });
})();
